var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListItem", {
    attrs: { "is-recipient": "" },
    scopedSlots: _vm._u([
      {
        key: "text",
        fn: function() {
          return [
            _c("div", [_vm._v(_vm._s(_vm.text))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-2" },
              [
                _c("Button", {
                  attrs: {
                    text: "Zugangsdaten (Link) senden",
                    icon: "key-chain"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("sendAccessLink")
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }